import { ChangeEvent } from 'react';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { SearchCheckboxItem } from 'components/SearchCheckboxList';
import classnames from 'classnames';
import { SearchConditionListType } from 'types/searchCondition';
import styles from './index.module.scss';

/**
 * フォームタイプのインターフェース
 */
interface FormType extends SearchConditionListType {
  /** コンポーネントの値 */
  value: string;
  /** 求人数 */
  jobCount: number;
}

/**
 * 検索条件設定コンポーネント こだわり条件でさらに絞る の Props
 */
interface Props<T, K> {
  /** 表示するリスト */
  list: T[];
  /** JobCountQueryのキー */
  type: keyof JobCountQuery;
  /** チェックボックスの選択状態を更新する関数 */
  updateIsCheckBox: (event: ChangeEvent<HTMLInputElement>) => K;
  /** 求人数を更新するための関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
  /** 追加のCSSクラス名 */
  propsClassName?: string;
}

/**
 * 検索条件設定コンポーネント こだわり条件でさらに絞る
 */
export const SelectiveSettingFormItem = <T extends FormType, K>({
  list,
  type,
  updateIsCheckBox,
  updateJobCount,
  propsClassName,
}: Props<T, K>) => {
  const onChangeCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    key: keyof JobCountQuery
  ) => {
    const checkedList = updateIsCheckBox(event);
    updateJobCount({ [key]: checkedList });
  };

  return (
    <div>
      <ul
        className={classnames(
          styles.SearchSelectiveSettingForm__searchCheckboxList__container,
          propsClassName && styles[propsClassName]
        )}
      >
        {list.map((item) => (
          <li key={item.id}>
            <SearchCheckboxItem
              title={item.name}
              value={item.value}
              isChecked={item.isChecked}
              onChange={(event) => onChangeCheckbox(event, type)}
              count={item.jobCount}
              size="L"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
